import type { AuthSession, UserSummary } from '@kitchen-inventory/shared-types';
import { create } from 'zustand';

import { createBrowserTokenStorage, type TokenStorage } from './token-storage.js';

export type SessionStatus = 'desconocida' | 'autenticada' | 'anonima';

interface SessionState {
  readonly status: SessionStatus;
  readonly user: UserSummary | undefined;
  readonly accessToken: string | undefined;
  readonly setSession: (session: AuthSession) => void;
  readonly clear: () => void;
  readonly markAnonymous: () => void;
}

const storage: TokenStorage = createBrowserTokenStorage(
  typeof globalThis.sessionStorage === 'undefined'
    ? { getItem: () => null, setItem: () => undefined, removeItem: () => undefined }
    : globalThis.sessionStorage,
);

export const sessionStore = create<SessionState>((set) => ({
  status: 'desconocida',
  user: undefined,
  accessToken: undefined,
  setSession(session): void {
    storage.write(session);
    set({ status: 'autenticada', user: session.user, accessToken: session.accessToken });
  },
  clear(): void {
    storage.clear();
    set({ status: 'anonima', user: undefined, accessToken: undefined });
  },
  markAnonymous(): void {
    set({ status: 'anonima', user: undefined, accessToken: undefined });
  },
}));

/** Lectura sincrónica para el transporte HTTP, que vive fuera de React. */
export function currentAccessToken(): string | undefined {
  const token = sessionStore.getState().accessToken;
  return token === undefined || token.length === 0 ? undefined : token;
}

export function storedRefreshToken(): string | undefined {
  const token = storage.read()?.refreshToken;
  return token === undefined || token.length === 0 ? undefined : token;
}

export const sessionTokenStorage = storage;
